<script>
import ImageSlider from './ImageSlider.vue';

export default {
    components: {
        ImageSlider,
    },
    data() {
        return {
            showAll: true,
            image: null,
        };
    },
    methods: {
        onDetails(image) {
            this.showAll = false;
            this.image = image;
        },
    },
};
</script>

<template>
    <div ref="container">
        <div v-if="showAll">
            <ImageSlider @showDetails="onDetails" />
        </div>
        <div v-else class="details" @click="showAll = true">
            <img :src="image.src" draggable="false" />
        </div>
        <div
            :class="[
                'cross-container',
                showAll ? 'cross-container--single' : 'cross-container--double',
            ]"
        >
            <svg viewBox="0 0 22 22">
                <polygon class="st0" points="22 11.751 0 11.751 0 10.249 22 10.249 22 11"></polygon>
                <polygon class="st0" points="11.751 0 11.751 22 10.249 22 10.249 0 11 0"></polygon>
            </svg>
            <svg v-if="!showAll" viewBox="0 0 22 22">
                <polygon class="st0" points="22 11.751 0 11.751 0 10.249 22 10.249 22 11"></polygon>
                <polygon class="st0" points="11.751 0 11.751 22 10.249 22 10.249 0 11 0"></polygon>
            </svg>
        </div>
        <h4 v-if="!showAll" class="header">{{ image.title }}</h4>
    </div>
</template>

<style lang="postcss" scoped>
.details {
    height: 100vh;
    width: 100vw;
    transition: all 0.7s ease;
}

.cross-container {
    position: absolute;
    top: 50%;
    right: 50%;
    transform: translate(50%, -50%);
    z-index: 2;
    pointer-events: none;
}

.cross-container--double {
    position: absolute;
    top: 50%;
    right: 50%;
    transform: translate(50%, -50%);
    display: flex;
    justify-content: space-between;
    width: 70vw;
    z-index: 2;
}

.header {
    position: absolute;
    top: 50%;
    right: 50%;
    transform: translate(50%, -50%);
    font-size: 24px;
    color: white;
    margin: 0;
}

.cross-container > svg {
    height: 24px;
    width: 24px;
    fill: white;
}
</style>
